export const ApplicableType = Object.freeze({
  ADMIN: 'ADMIN',
  MULTI: 'MULTI',
})
